import styled from 'styled-components';

export const AgGridTableWrapper = styled.div.attrs({
  className: 'ag-theme-quartz ag-theme-kinetik',
})`
  display: grid;
  grid-template-rows: 1fr auto;
  transition: ease all 200ms;
  gap: ${({ theme }) => theme.spacing.s2};
`;
